<template>
    <div>
        <!-- 收信箱 -->
        <div style="display: flex;justify-content: space-between;align-items: center;">
            <h3>{{ $t('lang.smartsms.inbox') }}</h3>
            <el-button size="mini" @click="refesh" type="primary">刷新</el-button>
        </div>
        <div class="overview">
            <div>
                {{ $t('lang.smartsms.storeState') }} {{ used }} /{{ total }}
            </div>
            <div>
                {{ $t('lang.smartsms.CurrentSIMCard') }} {{ simcard }}
            </div>
        </div>
        <el-divider></el-divider>
        <h3>{{ $t('lang.smartsms.messageList') }}</h3>
        <el-table :data="showList">
            <el-table-column :label="$t('lang.smartsms.serialNumber')" prop="index" width="100px"></el-table-column>
            <el-table-column :label="$t('lang.smartsms.telephoneNumber')" prop="phone" width="160px"></el-table-column>
            <el-table-column :label="$t('lang.smartsms.SMSContent')" prop="content" ></el-table-column>
            <el-table-column :label="$t('lang.smartsms.date')" prop="date" width="160px"></el-table-column>
            <el-table-column :label="$t('lang.smartsms.merge')" prop="merged" width="80px">
                <template slot-scope="scope">
                    {{ scope.row.merged ? $t('lang.smartsms.no') : $t('lang.smartsms.yes') }}
                </template>
            </el-table-column>
            <el-table-column width="120px" label="操作">
                <template slot-scope="scope">
                    <el-button @click="removeInboxMsg(scope.row.index, scope.$index)" size="mini" type="danger">{{
                        $t('lang.smartsms.delete') }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination :page-sizes="[5, 10, 25, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next"
                :total="list.length" :current-page="currentPage" @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            msg_threshold: "",
            used: "",
            total: "",
            simcard: "",
            list: [],
            pageSize: 10,
            currentPage: 1,
        };
    },
    computed: {
        // 计算属性的 getter
        // 用来计算当前页的数据
        // 用来计算当前页的数据
        showList() {
            let start = (this.currentPage - 1) * this.pageSize;
            let end = this.currentPage * this.pageSize;
            return this.list.slice(start, end);
        }
    },
    methods: {
        removeInboxMsg(index, iindex) {
            this.$confirm(this.$t('lang.smartsms.tips2'), this.$t('lang.smartsms.tips'), {
                confirmButtonText: this.$t('lang.smartsms.sure'),
                cancelButtonText: this.$t('lang.smartsms.cancel'),
                type: 'warning'
            }).then(() => {
                // 删除
                this.$emit("removeInboxMsg", {
                    index: index,
                    iindex: iindex
                });
            }).catch(() => {
            });
        },
        refesh() {
            this.$emit("refesh");
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    },
};
</script>
<style scoped>
h3 {
    font-size: 16px;
}

.input {
    width: 320px;
}

.tips {
    color: #999;
    font-size: 12px;
}

.foot {
    display: flex;
    justify-content: end;
}

.overview {
    display: flex;
    justify-content: space-around;
    margin-top: .5rem;
    align-items: center;
}

.pagination {
    margin-top: 1rem;
}
</style>
